// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"actions_headerContainer__2UU5v","actionsContainer":"actions_actionsContainer__VB9mU","actionsReviewNote":"actions_actionsReviewNote__JIfNT"};